import 'UI/Module'
import 'Glonass/UI/UI'
import 'Accounting/AttributeType'
import './Header'
import './Workspace'

/** @namespace Agronomy.UI */
NS("Agronomy.UI");
// todo придумать потом получше, это для того чтобы убрать явную ссылку в accounting на Agronomy
Accounting.AttributeType.itemForm = 'Agronomy.UI.Accounting.LightObjectForm'

/**
 * @class
 * @extends Glonass.UI.UI
 */
Agronomy.UI.UI = Class(Glonass.UI.UI, /** @lends Agronomy.UI.UI.prototype */ {
    headerClass: "Agronomy.UI.Header",
    workspaceClass: "Agronomy.UI.Workspace",

    spinnerStart() {
        _.invoke(this, 'header.spinnerStart');

        return this;
    },

    spinnerStop() {
        _.invoke(this, 'header.spinnerStop');

        return this;
    }
});
